module.exports = __webpack_public_path__ + "static/media/view-off.48384287.svg";